import { IIconProps } from './add';

export const IcoPublicStudy: React.FC<IIconProps> = ({ cy, style }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoPublicStudy${cy}`}
    style={style}
  >
    <path
      d="M6.99992 0.333008C3.31992 0.333008 0.333252 3.31967 0.333252 6.99967C0.333252 10.6797 3.31992 13.6663 6.99992 13.6663C10.6799 13.6663 13.6666 10.6797 13.6666 6.99967C13.6666 3.31967 10.6799 0.333008 6.99992 0.333008ZM1.66659 6.99967C1.66659 6.59301 1.71992 6.19301 1.80659 5.81301L4.99325 8.99967V9.66634C4.99325 10.3997 5.59325 10.9997 6.32659 10.9997V12.2863C3.70659 11.953 1.66659 9.71301 1.66659 6.99967ZM10.9266 10.5997C10.7533 10.0597 10.2599 9.66634 9.65992 9.66634H8.99325V7.66634C8.99325 7.29967 8.69325 6.99967 8.32659 6.99967H4.32659V5.66634H5.65992C6.02659 5.66634 6.32659 5.36634 6.32659 4.99967V3.66634H7.65992C8.39325 3.66634 8.99325 3.06634 8.99325 2.33301V2.05967C10.9466 2.84634 12.3333 4.76634 12.3333 6.99967C12.3333 8.38634 11.7933 9.65301 10.9266 10.5997Z"
      fill="#515252"
    />
  </svg>
);
